module.exports = __webpack_public_path__ + "manzama-error-43c71aa0715a6e76227eee0890238a8d.png";